import React, {useState, useEffect, useContext} from "react" ;

import ChildAppBody from "./Body/ChildAppBody";
import ChildAppSidebar from "./Sidebar/ChildAppSidebar";
import {useRecoilValue, useSetRecoilState} from "recoil";
import {currentChildAtom} from "root/recoil/childId";
import {getChildForUser} from "root/DataFunctions/ChildDataFns";
import {getDataFromResponse} from "root/DataFunctions/BaseDataFns";
import ChildModuleProvider from "root/Wieldy/ApplicationModules/Child/ChildModuleProvider";

const WieldyApplicationModuleChild = (props) =>
{
    const [height, setHeight] = useState(props.height);
    const [width, setWidth] = useState(props.width);
    const currentChild = useRecoilValue(currentChildAtom);
    const setCurrentChild = useSetRecoilState(currentChildAtom);

    const pageStyle = {height: '' + (+height - 1) + 'px'};

    useEffect(() => {
        setHeight(props.height);
        setWidth(props.width);
    }, [props.height, props.width]);

    useEffect(() => {
        if ( props.match.params.child_uid !== undefined )
        {
            getChildForUser( props.match.params.child_uid, 'current', (response) =>
            {
                const data = getDataFromResponse( response ) ;
                setCurrentChild( data[0] );
            })
        }
    }, [props.match.params.child_uid]);

    const getChildId = () =>
    {
        let child_uid= 0;
        child_uid = props.match.params.child_uid !== undefined ? props.match.params.child_uid : currentChild.child_uid;

        return child_uid;
    }

    return (
        <div className="row">
            <div className="col-xl-12">

                <div className="dt-module" style={pageStyle}>

                    <ChildModuleProvider>
                        {currentChild !== undefined && <ChildAppSidebar title={'Child'} child_uid={getChildId()} iconName={'icon-user-o'} height={props.height}/>}
                        {currentChild !== undefined && <ChildAppBody child_uid={getChildId()} height={height} width={width}/>}
                    </ChildModuleProvider>
                </div>
            </div>
        </div>
    );
}

export default WieldyApplicationModuleChild;